import { register } from 'async-ops';
import { callMdaePublicApi } from "../../../call-web-api";

export const MARK_DOCUMENT_SEEN = 'MARK_DOCUMENT_SEEN';

export const service = async (data) => {
    const options: object = {
        url: '/Api/Document/MarkDocumentSeen',
        type: "POST",
        contentType: 'application/json',
        isRoutedApiCall: true,
        body: JSON.stringify({
            attachedLevelId: data.attachedLevelId,
            attachedLevelName: data.attachedLevelName
        })
      }
      const response = callMdaePublicApi(options);
      return response;
};


const mockData = () => {
    return [];
  };
  
const mock = () => {
    const promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mockData());
      }, 2000);
    });
    return promise;
  };

register(MARK_DOCUMENT_SEEN, service, mock);
